module.exports = __webpack_public_path__ + "img/bust_dart_length.19d37582.png";